import React from 'react';
import { Label } from '../../UiKit';
import './modalHeader.scss';
import { grey } from 'sushiweb/tokens/color';
import { Cross } from 'sushiweb/Icons';

export const ModalHeader = ({
  title = '',
  subTtitle = '',
  handleClose = () => {},
  padding = 0,
  showCloseIcon = true,
  isCentered = false,
}) => {
  return (
    <div className='modalHeaderContainer col flex'>
      <div className='modalHeaderFirstRow row flex'>
        <div className='modalHeader col flex' style={{ padding: padding }}>
          <div className={`title ${isCentered ? 'center' : ''}`}>
            <span className='titleText dark big'>{title}</span>
          </div>
          {subTtitle && <p className='subTitle lighter'>{subTtitle}</p>}
        </div>
        <div>
          {showCloseIcon && (
            <span
              style={{ padding: padding }}
              className='iconMarginR crossIcon pointer'
              onClick={handleClose}
            >
              <Cross size={24} color={grey.z900} />
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
